import { ErrorPage } from '@/components/ErrorPage/ErrorPage.tsx';
import { ReloadIcon } from '@/components/icons/fetch-error';

export const NoConnectionPage = () => {
    const handleReloadPage = () => {
        window.location.reload();
    };

    return (
        <ErrorPage
            customStatus={<img src="/images/icons/wifi.svg" alt="" />}
            message="Нет интернет-соединения"
            buttonText={
                <>
                    <span>{ReloadIcon} Перезагрузить</span>
                </>
            }
            onClick={handleReloadPage}
        />
    );
};
